import React from 'react'
import ReactDOM from 'react-dom'
import { ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import store from './store'
import { Provider } from 'react-redux'
import zhCN from 'antd/es/locale/zh_CN'
import 'dayjs/locale/zh-cn'
import App from './App'

dayjs.locale('zh-cn')

ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
)
